import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _HeatmapLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M3 3v14.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 21 5.08 21 6.2 21H21" }),
            React.createElement("path", { fill: "currentColor", d: "M9.37 4H6v3.38h3.37zM10.815 7.38V4h3.37v3.38zM9.37 12.69V9.31H6v3.38zM10.815 12.69V9.31h3.37v3.38zM15.63 12.69V9.31H19v3.38zM14.185 18v-3.38h-3.37V18zM15.63 18v-3.38H19V18z" })));
}
const HeatmapLight = forwardRef(_HeatmapLight);
export { HeatmapLight };
